export const SPOTIFY_LOGIN_URL =
  'https://accounts.spotify.com/authorize?client_id=a4316da1408644a9b8b36e367ec37a58&redirect_uri=http:%2F%2Flocalhost:3000%2Fhome&scope=user-read-private%20user-read-email%20playlist-modify-private&response_type=token&state=123';

export const SPOTIFY_LOGIN_URL_TEST =
  'https://accounts.spotify.com/authorize?client_id=a4316da1408644a9b8b36e367ec37a58&redirect_uri=https:%2F%2Fspotifyplaylistgenerator-9c6ce.web.app%2Fhome&scope=user-read-private%20user-read-email%20playlist-modify-private&response_type=token&state=123';
